import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import getDynamicPaymentScheduleDepositAmount from './getDynamicPaymentScheduleDepositAmount'
import getDynamicPaymentScheduleServiceFee from './getDynamicPaymentScheduleServiceFee'

const getDynamicPaymentScheduleMerchantFeeEligibleAmount = createSelector(
  getDynamicPaymentScheduleDepositAmount,
  getDynamicPaymentScheduleServiceFee,
  (depositAmount, dynamicPaymentScheduleServiceFee): number => {
    return floatify(depositAmount - dynamicPaymentScheduleServiceFee)
  },
)

export default getDynamicPaymentScheduleMerchantFeeEligibleAmount
